import pairingErrors from '../consts/device/pairingErrors';
import {makeSelectIotDeviceMergedWithConsumerProduct} from '../state/selectors/consumer';
import {selectIsDeviceNotSupported, selectIsDeviceReady, selectIsWrongDevice} from '../state/selectors/iotDevice';
import {makeSelectIsYapDeviceInfoReceived, makeSelectIsYapHolderInfoReceived} from '../state/selectors/yapEncrypted';
import {getState} from '../state/store';
import helpers from '../utils/helpers';
import pairingService from './pairingService';

let instance = null;

export default class ErrorHandlerService {
    constructor() {
        if (instance) {
            return instance;
        }

        instance = this;
        this.pairingErrorHandler = null;
    }

    setPairingErrorHandler({handler}) {
        this.pairingErrorHandler = handler;
    }

    removeErrorHandler() {
        this.pairingErrorHandler = null;
    }

    checkYapError(isHolder) {
        const state = getState();
        const isDeviceReady = selectIsDeviceReady(state);
        const isYapDeviceInfoReceived = makeSelectIsYapDeviceInfoReceived()(state);
        const isYapHolderInfoReceived = makeSelectIsYapHolderInfoReceived()(state);
        const isInfoReceived = isHolder ? isYapHolderInfoReceived : isYapDeviceInfoReceived;
        const iotProduct = makeSelectIotDeviceMergedWithConsumerProduct()(state);
        const {holder, device} = iotProduct || {};
        const {isHolderConnected} = device || {};
        const {deviceSerialNumber} = holder || {};

        if ((isDeviceReady || (isHolderConnected && deviceSerialNumber)) && isInfoReceived) return;

        if (typeof this.pairingErrorHandler === 'function') {
            const getCode = () => {
                const isWrongDevice = selectIsWrongDevice(state);

                if (isWrongDevice) return pairingErrors.ERROR_WRONG_DEVICE;

                const isDeviceNotSupported = selectIsDeviceNotSupported(state);

                if (isDeviceNotSupported) return pairingErrors.ERROR_NOT_SUPPORTED_DEVICE;

                return pairingErrors.ERROR_PAIRING;
            };
            const code = getCode();

            helpers.runFunction(this.pairingErrorHandler, [code, isHolder]);
        } else {
            if (isHolder) {
                pairingService.disconnectAndClearHolderState();
            } else {
                pairingService.disconnectAndShowCriticalGuide();
            }
        }
    }
}
